// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'speed-js-react';
import TrialPeriodQueue from 'src/navigation/TrialPeriodQueue';
import Home from './Home';
import Stack from './Stack';
import {
    HOME_SCREEN,
    LOGIN_SCREEN,
    CREATE_DEVICE_SCREEN,
    EDIT_PROFILE_SCREEN,
    CREATE_PROFILE_SCREEN,
    EDIT_DEVICE_SCREEN,
    AUTO_LOGIN_COMPLETE_SCREEN,
    TRIAL_PERIOD_START,
    TRIAL_PERIOD_QUEUE,
    TRIAL_PERIOD_ACTIVATE,
} from './constants';
import Login from './Login/Login';
import CreateDevice from './CreateDevice/CreateDevice';
import Profile from './Profile/Profile';
import EditDevice from './EditDevice/EditDevice';
import Header from '../components/Header/CustomHeader';
import LoginAuto from './LoginAuto';
import AbsoluteActivityIndicator from '../components/AbsoluteActivityIndicator';
import StartTrialPeriod from './StartTrialPeriod';
import ActivateTrialPeriod from './ActivateTrialPeriod';

const RootStack = (): React.Node => {
    const user = useSelector(getUser);
    if (typeof user === 'undefined') {
        return <AbsoluteActivityIndicator />;
    }

    return (
        <Stack.Navigator name="Root" screenOptions={{ header: () => <Header /> }}>
            {!user
                ? (
                    <>
                        <Stack.Screen
                            name={LOGIN_SCREEN}
                            component={Login}
                            options={
                                { title: 'Портал за управление на coool.tv - Вход' }
                            }
                        />
                        <Stack.Screen
                            name={AUTO_LOGIN_COMPLETE_SCREEN}
                            component={LoginAuto}
                            options={
                                { title: 'Портал за управление на coool.tv - Вход' }
                            }
                        />
                    </>
                )
                : (
                    <>
                        <Stack.Screen
                            name={HOME_SCREEN}
                            component={Home}
                            options={
                                { title: 'Портал за управление на coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={TRIAL_PERIOD_START}
                            component={StartTrialPeriod}
                            options={
                                { title: 'Портал за управление на coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={TRIAL_PERIOD_QUEUE}
                            component={TrialPeriodQueue}
                            options={
                                { title: 'Портал за управление на coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={TRIAL_PERIOD_ACTIVATE}
                            component={ActivateTrialPeriod}
                            options={
                                { title: 'Портал за управление на coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={CREATE_PROFILE_SCREEN}
                            component={Profile}
                            options={
                                { title: 'Управление на профили при coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={CREATE_DEVICE_SCREEN}
                            component={CreateDevice}
                            options={
                                { title: 'Добавяне на устройства при coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={EDIT_PROFILE_SCREEN}
                            component={Profile}
                            options={
                                { title: 'Управление на профили при coool.tv' }
                            }
                        />
                        <Stack.Screen
                            name={EDIT_DEVICE_SCREEN}
                            component={EditDevice}
                            options={
                                { title: 'Управление на устройства при coool.tv' }
                            }
                        />
                    </>
                )}
        </Stack.Navigator>
    );
};
export default RootStack;
